import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react'
import { PaypalButton } from './PaypalButton';

const FormPayment = (props: IFormPaymentProps) => {
    const {
        orderId,
        isCodeValid,
        totalDiscountPercentPerCode,
        totalDiscountPercentPerTimer,
        totalPrice
    } = props.payload;

    const [showContent, setShowContent] = useState(true);

    const hasDiscount = totalDiscountPercentPerCode !== 0 || totalDiscountPercentPerTimer !== 0;
    const totalPriceWithDiscount = totalPrice - (totalDiscountPercentPerCode / 100 * totalPrice) - (totalDiscountPercentPerTimer / 100 * totalPrice);

    return (
        <Stack spacing={5}>
            {showContent && hasDiscount && (
                <img style={{
                    maxWidth: 150,
                    width: '100%',
                    alignSelf: 'center'
                }} src={require("../../../../assets/images/firework.png")} />
            )}
            <Stack spacing={0.5}>
                <Typography variant='h4' textAlign='center'>
                    ${totalPriceWithDiscount.toFixed(2)}
                </Typography>
                {hasDiscount && (
                    <Typography variant='body1' textAlign='center'>
                        Tú ahorras <span style={{ color: '#4caf50' }}>${(
                            totalPrice - totalPriceWithDiscount
                        ).toFixed(2)} ({(
                            (totalDiscountPercentPerCode + totalDiscountPercentPerTimer).toFixed()
                        )}%)</span>
                    </Typography>
                )}
            </Stack>
            {showContent && (
                <Typography variant='body1' textAlign='center'>
                    Haz clic en el siguiente botón para iniciar&#160;la&#160;compra
                </Typography>
            )}
            <PaypalButton 
                orderId={orderId}
                onChangeState={(isOpen) => setShowContent(isOpen === false)}
                onSuccess={props.onSuccess}
                onFailure={props.onFailure} />
        </Stack>
    );
}

export { FormPayment }